import StrengthsMap from "@/components/Exercises/StrengthsMap/StrengthsMap";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useChildSessionStore } from "@/lib/stores/childSessionStore";
import { z } from "zod";

const strengthsMapSearchSchema = z.object({
  step: z.string().optional(),
});

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/strengths-map/"
)({
  component: RouteComponent,
  validateSearch: strengthsMapSearchSchema,
  head: () => ({
    meta: [
      {
        title: "My Strengths Map - HAMD",
      },
    ],
  }),
  beforeLoad: ({ search }) => {
    const stepTitleMap: Record<string, string> = {
      title: "strengthsMap.title",
      discover: "strengthsMap.step1.title",
      whatAreStrengths: "strengthsMap.step2.title",
      buildWheel: "strengthsMap.step3.title",
      selectStrengths: "strengthchooseStrengthse",
      reflection: "strengthsMap.step5.title",
      decoration: "strengthsMap.step6.title",
      finalReflection: "strengthsMap.step7.title",
    };
    
    const step = search.step || "title";
    return {
      title: stepTitleMap[step] || "strengthsMap.title",
      navbar: {
        onBack: false,
        showTopbar: false,
      },
    };
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const { selectedEmotionId, setStep } = useChildSessionStore();

  const handleComplete = () => {
    if (selectedEmotionId) {
      navigate({ to: "/children/session" });
    } else {
      navigate({ to: "/children/exercises" });
    }
  };

  const handleExit = () => {
    if (selectedEmotionId) {
      setStep("exercise");
      navigate({ to: "/children/session" });
    } else {
      navigate({ to: "/children/exercises" });
    }
  };

  return <StrengthsMap onComplete={handleComplete} onExit={handleExit} />;
}
